import { GoDotFill } from "react-icons/go"
import { Container, Navbar } from "reactstrap"
import styled from "styled-components"
import Theme from "../../../theme"

export const StyledNavbar = styled(Navbar).attrs(() => ({
    className: "navbar-top fixed-top navbar-light bg-white shadow  d-flex", expand: "md",
    id: "navbar-main"
}))`height:"80px"`



export const StyledContainer = styled(Container).attrs(() => ({
    className: "d-flex flex-row justify-content-between mt-2 align-items-center", fluid: true
}))``



export const StyledGoDot = styled(GoDotFill)`
color: ${Theme.danger};
position: relative;
right: 19px;
top: -12px;
`


export const StyledSpan = styled.span.attrs(() => ({
    className: "avatar avatar-sm rounded-circle mr-2"
}))`
background-image: url(${props => props.img});
background-size: cover;
background-position: center;
z-index: 9;`